/* ============================================================================
   FF Info Tabs — Custom Element
   Handles desktop tab switching only.
   Mobile accordion animation is handled by the site-wide ff-details-animate.js
   via the .accordion > details selector pattern.
   Created: Mar 2 2026
   ============================================================================ */
(function () {
  'use strict';

  class FFInfoTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.ff-it__tab'));
      this.panels = Array.from(this.querySelectorAll('.ff-it__panel'));

      if (!this.tabs.length) return;

      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', this.onTabClick.bind(this));
        tab.addEventListener('keydown', this.onKeyDown.bind(this));
      }.bind(this));

      /* Activate first tab if none active */
      var hasActive = this.tabs.some(function (t) {
        return t.getAttribute('aria-selected') === 'true';
      });
      if (!hasActive && this.dataset.autoOpen !== 'false') {
        this.activateTab(this.tabs[0], false);
      }
    }

    onTabClick(e) {
      this.activateTab(e.currentTarget, true);
    }

    onKeyDown(e) {
      var idx = this.tabs.indexOf(e.currentTarget);
      var next;

      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();
          next = this.tabs[(idx + 1) % this.tabs.length];
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();
          next = this.tabs[(idx - 1 + this.tabs.length) % this.tabs.length];
          break;
        case 'Home':
          e.preventDefault();
          next = this.tabs[0];
          break;
        case 'End':
          e.preventDefault();
          next = this.tabs[this.tabs.length - 1];
          break;
      }

      if (next) {
        this.activateTab(next, true);
        next.focus();
      }
    }

    activateTab(tab, animate) {
      var panelId = tab.getAttribute('aria-controls');
      var panel = this.querySelector('#' + panelId);
      if (!panel) return;

      /* Deactivate all */
      this.tabs.forEach(function (t) {
        t.setAttribute('aria-selected', 'false');
        t.setAttribute('tabindex', '-1');
      });
      this.panels.forEach(function (p) {
        p.setAttribute('aria-hidden', 'true');
      });

      /* Activate target */
      tab.setAttribute('aria-selected', 'true');
      tab.setAttribute('tabindex', '0');
      panel.setAttribute('aria-hidden', 'false');
    }
  }

  if (!customElements.get('ff-info-tabs')) {
    customElements.define('ff-info-tabs', FFInfoTabs);
  }
})();